<div class="shimmer-container m-2">
<div class="shimmer-wrapper" *ngFor="let i of [].constructor(blocks)">
    <div class="shimmer"></div>
    <div class="shimmer-box w-100" *ngIf="0<lines"></div>
    <div class="shimmer-box w-75" *ngIf="1<lines"></div>
    <div class="shimmer-box w-50" *ngIf="2<lines"></div>
  </div>
</div>